module.exports = __webpack_public_path__ + "static/media/Basal_4542.e8d6380c.jpg";